import { createStore } from 'vuex'

export default createStore({
  state: {
    endpoint: process.env.VUE_APP_API_PATH
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
